// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"7":"generate","697":"donate"}[chunkId] || chunkId) + "." + {"7":"9beeef53","446":"4d856dc2","697":"79eb507f"}[chunkId] + ".js";
};